import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';

@Component({
    selector: 'arrow-back',
    imports:[MatIconModule],
    template: `
    
        <span class="cursor-pointer" (click)="goBack()"> <mat-icon>arrow_back</mat-icon> </span>
    `
})

export class ArrowBackComponent  {
    constructor(private _location: Location) { }
    
    goBack() {
        this._location.back();
    }


}